import { adresVarMi } from './email-mask-desen';
export const AT_ISARETLERI = '@＠';
/**
 * `@`YE BİTİŞİK BOŞLUK KÜMESİNİ TEK BOŞLUĞA İNDİRİR — EŞİĞİN TABANI BUDUR.
 *
 * Panelde `lastError` sıradan bir `<span>` içinde çizilir ve HTML'de ARDIŞIK
 * BOŞLUK KÜMESİ TEK BOŞLUĞA ÇÖKER — satır sonu dahil. Yani `ali`, dokuz boşluk,
 * `@`, `ornek.com` ekranda `ali @ornek.com` diye OKUNUR. Metindeki boşluk
 * sayısı personelin gördüğü şeyi değiştirmez; kanonik biçim de değiştirmemeli.
 * Eşikli eski hâl dokuz boşlukla, satır sonuyla, `%20` ve `&nbsp;` dolgusuyla
 * atlatılıyordu (bir EŞİK, aşılabilir olduğu sürece aşılır).
 *
 * TEK BOŞLUĞA İNDİRİLİR, SİLİNMEZ: silmek `Error @ line 5`i `Error@line 5`
 * yapar ve bitişik dal onu adres sayardı.
 */
/** Hızlı yolun İSPATI kapıda ölçülür (`email-mask-kesim.spec.ts` 21. AYAK). */
export const AT_BITISIK_BOSLUK = /\s+(?=[@＠])|(?<=[@＠])\s+/gu;
export function boslugaIndirge(metin) {
    /*
     * HIZLI ÇIKIŞ — ÖLÇÜLDÜ. Desenin İKİ almaşığı da `@`ye çapalıdır: at işareti
     * YOKSA eşleşme de yoktur, yani bu satır bir KISAYOL DEĞİL, ispatlı bir no-op
     * atlamasıdır. `\s+(?=[@＠])` uzun boşluk kümesinde karesel geri izler; 2000
     * boşluklu girdide maskeleme 246,6 ms sürüyordu, bu satırla 1,6 ms'ye iner.
     */
    if (!/[@＠]/u.test(metin))
        return metin;
    AT_BITISIK_BOSLUK.lastIndex = 0;
    return metin.replace(AT_BITISIK_BOSLUK, ' ');
}
/** İçerikte HERHANGİ bir at işareti var mı? Ocak kararının UCUZ ön elemesi. */
function icerikteAtVar(icerik) {
    return [...AT_ISARETLERI].some((isaret) => icerik.includes(isaret));
}
/** Verilen madde kümesini SÖKEREK uygular — ocak kararının ikinci okuması. */
function sokHepsi(metin, maddeler) {
    return maddeler.reduce((sonuc, madde) => madde.sok(sonuc, maddeler), metin);
}
/**
 * OCAK KARARININ ÖLÇÜTÜ — "İÇERİKTE `@` VAR MI" DEĞİL, "ADRES OKUNUYOR MU".
 *
 * İki okuma denenir: içeriğin KENDİSİ ve içeriğin TÜM atıl maddelerden arınmış
 * hâli. İkincisi gerekli, çünkü dıştaki ocağın içinde adres BAŞKA BİR atıl
 * türle bölünmüş olabilir (`<!-- qd<b>x</b>@ornek.com -->`).
 *
 * `@` ÖN ELEMESİ KORUNUR ve ucuzdur: at işareti yoksa hiçbir okuma adres
 * üretemez, pahalı `sokHepsi` çağrısı hiç yapılmaz. Sağlayıcı metinlerinin
 * çoğunda ocak içeriği `@` taşımaz.
 */
function icerikteAdresVar(icerik, maddeler) {
    if (!icerikteAtVar(icerik))
        return false;
    if (adresVarMi(boslugaIndirge(icerik)))
        return true;
    return adresVarMi(boslugaIndirge(sokHepsi(icerik, maddeler)));
}
/** DOKUZUNCU DALGA — üretim ölçütü. */
export const OZYINELEMELI_OLCUT = {
    ad: 'ozyinelemeli-adres',
    ozyinelemeli: true,
    ac: icerikteAdresVar,
};
/** SEKİZİNCİ DALGANIN ÖLÇÜTÜ — yalnız mutasyon probu için dışa açılır. */
export const TEK_ADIMLIK_OLCUT = {
    ad: 'tek-adimlik-at',
    ozyinelemeli: false,
    ac: (icerik) => icerikteAtVar(icerik),
};
/**
 * OCAK ÇIKTISI — üç kipin TEK karar noktası.
 *
 * `bosSok` sökme kararının ne bıraktığıdır: desenli maddelerde bir AYIRICI
 * boşluk (sınırlayıcı orada bir sınır işaretiydi), yorum tarayıcılarında HİÇBİR
 * ŞEY (yorum `@`ye çapalıdır, oraya boşluk koymak adresi ikiye bölerdi).
 */
export function ocakCiktisi(icerik, kip, maddeler, ozyinele, bosSok, olcut) {
    if (kip === 'sok')
        return bosSok;
    if (kip === 'ayir')
        return ` ${icerik} `;
    const oz = olcut.ozyinelemeli ? ozyinele(icerik) : icerik;
    return olcut.ac(oz, maddeler) ? ` ${oz} ` : bosSok;
}
//# sourceMappingURL=email-mask-atil.js.map